export const BRAND_LOGOS_BUCKET = "brand-logos";

export const INDUSTRIES = [
  "Fashion",
  "Beauty",
  "Fintech",
  "D2C",
  "SaaS",
  "Lifestyle",
  "Consumer Electronics",
  "Retail",
  "Fitness & Wellness",
  "Food & Beverage",
  "Gaming",
  "Entertainment",
  "Travel & Hospitality",
  "Other",
];
